import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from 'api/Api';

export type RecordingLimitValue = number | null;

export type RecordingLimitsConfig = {
  warningDurationSeconds: RecordingLimitValue;
  maxDurationSeconds: RecordingLimitValue;
  warningSizeBytes: RecordingLimitValue;
  maxSizeBytes: RecordingLimitValue;
};

const pickPositiveNumber = (value: unknown): number | null => {
  if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) {
    return null;
  }

  return value;
};

export const normalizeRecordingLimitsConfig = (payload: unknown): RecordingLimitsConfig => {
  const source = payload && typeof payload === 'object' ? (payload as Record<string, unknown>) : {};

  return {
    warningDurationSeconds: pickPositiveNumber(source.warningDurationSeconds),
    maxDurationSeconds: pickPositiveNumber(source.maxDurationSeconds),
    warningSizeBytes: pickPositiveNumber(source.warningSizeBytes),
    maxSizeBytes: pickPositiveNumber(source.maxSizeBytes)
  };
};

export const commonApi = createApi({
  baseQuery: baseQueryWithReAuth,
  reducerPath: 'commonApi',
  endpoints: (build) => ({
    getRecordingLimits: build.query<RecordingLimitsConfig, void>({
      query: () => ({
        url: '/config/recording-limits',
        method: 'GET'
      }),
      transformResponse: (response: unknown) => normalizeRecordingLimitsConfig(response)
    }),
    contactUs: build.mutation<boolean, { message: string }>({
      query: (body) => ({
        url: '/common/contact-us',
        method: 'POST',
        body
      }),
      transformResponse: (response: { success: boolean }) => response.success
    })
  })
});

export const { useContactUsMutation, useGetRecordingLimitsQuery } = commonApi;
